import { PiiLookupView } from "@/shared-screens/pii-lookup/pii-lookup-view";
import { ProductRecommendationsView } from "@/shared-screens/product-recommendations/product-recommendations-view";
import { useSuperAdminAllShops } from "@babackapp/private-api-client/client/use-super-admin-all-shops";
import { useParams } from "react-router-dom";
import { AdminPageShell } from "./admin-tab-pages";

/**
 * Screens shared with Returns (`src/shared-screens`), rendered inside the
 * admin: same component, admin chrome and admin links (ScreenLinksProvider
 * in the layout). The shop comes from `/admin/shops/:shopId`.
 */
export function useAdminShop(): { shopId: string; shopName: string } {
  const { shopId = "" } = useParams<{ shopId: string }>();
  // Loaded by the shop selector already: cached.
  const { data: shops } = useSuperAdminAllShops(true);
  const shopName = shops?.find((shop) => shop.id === shopId)?.name ?? shopId;
  return { shopId, shopName };
}

export function AdminShopPiiLookupPage() {
  const { shopId, shopName } = useAdminShop();

  return (
    <AdminPageShell title={`Données personnelles · ${shopName}`}>
      <PiiLookupView shopId={shopId} shopName={shopName} />
    </AdminPageShell>
  );
}

const RECO_DESCRIPTION =
  "Outil de test de l'algorithme de recommandations, basé sur les co-occurrences de produits dans les commandes (Lift + Jaccard).";

/** Global under /admin/product-recommendations, tester pre-filled per shop. */
export function AdminProductRecommendationsPage() {
  const { shopId } = useParams<{ shopId?: string }>();
  const { shopName } = useAdminShop();

  return (
    <AdminPageShell
      title={shopId ? `Reco produit · ${shopName}` : "Reco produit"}
      description={RECO_DESCRIPTION}
    >
      <ProductRecommendationsView key={shopId} defaultShopId={shopId} />
    </AdminPageShell>
  );
}
